import { render, staticRenderFns } from "./ForgetPwdAcc.vue?vue&type=template&id=6db5e283&"
import script from "./ForgetPwdAcc.vue?vue&type=script&lang=js&"
export * from "./ForgetPwdAcc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports